<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { DashboardRole } from '../../lib/dashboard/resolve';

  let {
    title,
    subtitle = '',
    variant = 'admin' as DashboardRole | 'admin',
    children,
    actions,
  }: {
    title?: string;
    subtitle?: string;
    variant?: DashboardRole | 'admin';
    children: Snippet;
    actions?: Snippet;
  } = $props();
</script>

<section class="dash dash-{variant}">
  {#if actions}<header class="head"><div class="head-actions">{@render actions()}</div></header>{/if}
  {@render children()}
</section>

<style>
  .dash { display: flex; flex-direction: column; gap: 0.25rem; }
  .head { display: flex; justify-content: flex-end; align-items: center; gap: 1rem; margin-bottom: 0.75rem; flex-wrap: wrap; }
  .head-actions { display: flex; gap: 0.5rem; align-items: center; }

  :global(.dash-grid) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 0.85rem;
  }
  :global(.col-3) { grid-column: span 3; }
  :global(.col-4) { grid-column: span 4; }
  :global(.col-6) { grid-column: span 6; }
  :global(.col-8) { grid-column: span 8; }
  :global(.col-12) { grid-column: span 12; }
  @media (max-width: 960px) {
    :global(.col-3), :global(.col-4), :global(.col-6), :global(.col-8) { grid-column: span 12; }
  }
</style>
